import ScorecardReportPath from './wizard/scorecard-report/scorecard-report-path'
import InitiativeReportPath from './wizard/initiative-report/initiative-report-path'
import DatasetReportPath from './wizard/dataset-report/dataset-report-path'
import SqlConsolePath from './wizard/sql-console/sql-console-path'
import permissions from 'scoreboard/components/permissions'

/**
 * Returns An array of options which are used in creating new reports
 */
function reportTypes() {
	let types = [{
		title: 'admin.scorecards.scorecards',
		value: 'scorecards',
		icon: 'scorecard-large',
		path: ScorecardReportPath
	}, {
		title: 'initiatives.initiatives',
		value: 'initiatives',
		icon: 'initiative-large',
		path: InitiativeReportPath
	}, {
		title: 'datasets.datasets',
		value: 'datasets',
		icon: 'add-widget-dataset',
		path: DatasetReportPath
	}]

	if (permissions.appAdmin() || permissions.readOnlySqlConsole()) {
		types.push({
			title: 'report.designer.type.sql',
			value: 'sql',
			icon: 'sql',
			path: SqlConsolePath
		})
	}
	return types
}

export default reportTypes
reportTypes.__filename__ = 'reports/report-types.js'
